import { render, staticRenderFns } from "./ButtonClone.vue?vue&type=template&id=c5eec31a"
import script from "./ButtonClone.vue?vue&type=script&lang=js"
export * from "./ButtonClone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports